import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MarkdownDoc } from '../components/MarkdownDoc';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Sentry } from '../lib/sentry';

const Policy: React.FC = () => {
  const { type } = useParams<{ type: string }>();

  const { docPath, title } = useMemo(() => {
    if (type?.toUpperCase() === 'TOS') {
      return { docPath: '/policy/TOS.md', title: 'Terms of Service' };
    }
    if (type?.toUpperCase() === 'PRIVACY') {
      return { docPath: '/policy/PRIVACY.md', title: 'Privacy Policy' };
    }

    Sentry.captureMessage('POLICY_LOAD_FAIL', {
      level: 'warning',
      extra: { type },
    });

    return { docPath: '/policy/PRIVACY.md', title: 'Privacy Policy' };
  }, [type]);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center space-x-4"
          >
            <Link
              to="/profile"
              className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700"
            >
              <ArrowLeftIcon className="h-4 w-4 mr-1" />
              Back to Profile
            </Link>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 }}
            className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate mt-2"
          >
            {title}
          </motion.h2>
        </div>
      </div>

      {/* Policy Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="card"
      >
        <div className="card-body">
          <MarkdownDoc docPath={docPath} renderAs="raw" />
        </div>
      </motion.div>
    </div>
  );
};

export default Policy;
